import React from 'react'
import {
  Bullet,
  Bullets,
  Info,
  Page,
  Screenshot,
  Section,
} from '../../../components/CommandControlComponents'

const CrewMessaging = () => (
  <Page
    title="Crew Messaging"
    intro="Every resource has a message thread between the control room and the crew's phones, so routine traffic stays off the radio and is recorded against the resource."
  >
    <Section title="Opening a conversation">
      <Bullets>
        <Bullet>Click the messages icon in the Resources header to open the chat drawer, which lists every resource conversation in the room.</Bullet>
        <Bullet>Conversations with unread crew messages are highlighted and sorted to the top; the header icon shows the total unread count.</Bullet>
        <Bullet>You can also jump straight to a resource's thread from the message button on its resource card or from the resource drawer.</Bullet>
        <Bullet>Opening a conversation marks its crew messages as read for the whole control room — not just for you.</Bullet>
      </Bullets>
      <Screenshot url="command-control/crew-messaging.png">
        Chat drawer showing the resource conversation list with unread badges
        and an open thread with the composer.
      </Screenshot>
    </Section>

    <Section title="Sending and receiving">
      <Bullets>
        <Bullet>Type in the composer at the bottom of a thread to message the crew; messages arrive in the mobile app for everyone crewed on the resource.</Bullet>
        <Bullet>Each control message also sends a push notification to every crew member on the resource, so a message is seen even with the app in the background.</Bullet>
        <Bullet>Crew replies appear in the thread and trigger a short alert tone in the control room when a new unread message arrives.</Bullet>
        <Bullet>Threads refresh automatically while open — there is no need to reload.</Bullet>
      </Bullets>
      <Info>
        Browsers only allow sound after the operator has interacted with the
        page, so the very first alert after a fresh page load may be silent.
      </Info>
    </Section>

    <Section title="Chat on an incident">
      <Bullets>
        <Bullet>While a resource is assigned to an incident, every message in its thread — control messages and crew replies alike — is stamped with that incident.</Bullet>
        <Bullet>Stamped messages appear in the incident's log alongside the timeline entries, marked with a chat chip showing the direction: Control → call sign, or call sign → Control.</Bullet>
        <Bullet>This keeps the operational conversation about a job on the incident record without operators having to copy messages into logs.</Bullet>
      </Bullets>
    </Section>

    <Section title="Who can do this?">
      <Bullets>
        <Bullet>Reading threads and marking them as read requires Viewer access or above.</Bullet>
        <Bullet>Sending a message requires Dispatcher or Call Taker access (or above) — for Viewers the composer is hidden, and the server enforces the same rule.</Bullet>
      </Bullets>
    </Section>
  </Page>
)

export default CrewMessaging
